import axiosInstance from "../config/axios.config";

export const emailLoginApi = (payload) => {
  return axiosInstance.post("accounts/email-login/", payload);
};
export const mobileLoginApi = (payload) => {
  return axiosInstance.post("accounts/phone-login/", payload);
};
export const mobileOtpLoginApi = (payload) => {
  return axiosInstance.post("accounts/otp-login/", payload);
};
export const mobileOtpResendApi = (payload) => {
  return axiosInstance.post("accounts/otp-resend/", payload);
};
export const verifyOtpApi = (payload) => {
  return axiosInstance.post("accounts/otp-verify/", payload);
};
export const logoutApi = () => {
  return axiosInstance.post("accounts/logout");
};
export const getGstApi = () => {
  return axiosInstance.get(`/accounts/list-org-gstin/`);
};
export const getCinApi = () => {
  return axiosInstance.get(`/accounts/list-org-cin/`);
};
export const userMetaDataApi = () => {
  return axiosInstance.get("accounts/user-details/");
};
export const orgVerificationApi = (domain) => {
  return axiosInstance.get(`accounts/org-details/?domain=${domain}`);
};
export const addUserApi = (payload) => {
  return axiosInstance.post(`accounts/add-user/`, payload);
};
export const updateUserApi = (payload, config = {}) => {
  return axiosInstance.patch(`accounts/update-user/`, payload, config);
};
export const updateUserRoleApi = (payload) => {
  return axiosInstance.patch(`accounts/update-user-role/`, payload);
};
export const usersListApi = (queryParams = {}) => {
  return axiosInstance.get(`accounts/org-users-list/`, {
    params: queryParams,
  });
};
export const changePasswordApi = (payload) => {
  return axiosInstance.post(`accounts/change-password/`, payload);
};
export const addGstApi = (payload) => {
  return axiosInstance.post(`accounts/add-gstin/`, payload);
};
export const addCinApi = (payload) => {
  return axiosInstance.post(`accounts/add-cin/`, payload);
};
export const deactivateUserApi = (payload) => {
  return axiosInstance.patch(`accounts/deactivate-user/`, payload);
};
export const SetPasswordApi = (params, payload) => {
  return axiosInstance.post(`accounts/set-password/?token=${params}`, payload);
};

/**
 * Pharmacy Admin adds pharmacist staff and HODs.
 *
 * Distinct from accounts/add-user/, which only an Org Admin may call: this one
 * can assign the Pharmacist role only, and cannot create another Pharmacy
 * Admin (is_admin must be omitted).
 */
export const addPharmacyUserApi = (payload) => {
  return axiosInstance.post("accounts/pharmacy/add-user/", payload);
};
